const n = (e, r = []) => Array.isArray(r) ? r.find((i) => i.key === e) : r[e];
export {
  n as findColumnByKey
};
